vec3 effect(vec2 uv)
{
    vec2 cells = uResolution / uPixelSize;
    return sampleCam((floor(uv * cells) + 0.5) / cells);
}
